import React, { useState } from 'react';
import { Table, Button, Card, Space, Upload, message, Modal, Descriptions, Tag } from 'antd';
import { UploadOutlined, EyeOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

const DeviceProfileManagement = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentProfile, setCurrentProfile] = useState<any>(null);

  // Mock data for device profiles
  const data = [
    {
      key: '1',
      manufacturer: 'Google',
      model: 'Pixel 6 Pro',
      androidVersion: '12',
      collectedBy: 'Admin (Manual)',
      collectedAt: '2025-11-20 10:00:00',
      status: 'Active',
    },
    {
      key: '2',
      manufacturer: 'Samsung',
      model: 'Galaxy S21',
      androidVersion: '11',
      collectedBy: 'Device Collector App',
      collectedAt: '2025-11-21 14:30:00',
      status: 'Active',
    },
    {
      key: '3',
      manufacturer: 'Xiaomi',
      model: 'Mi 11',
      androidVersion: '11',
      collectedBy: 'Device Collector App',
      collectedAt: '2025-11-22 09:15:00',
      status: 'Inactive',
    },
  ];

  const columns = [
    {
      title: 'Manufacturer',
      dataIndex: 'manufacturer',
      key: 'manufacturer',
    },
    {
      title: 'Model',
      dataIndex: 'model',
      key: 'model',
    },
    {
      title: 'Android Version',
      dataIndex: 'androidVersion',
      key: 'androidVersion',
    },
    {
      title: 'Collected By',
      dataIndex: 'collectedBy',
      key: 'collectedBy',
    },
    {
      title: 'Collected At',
      dataIndex: 'collectedAt',
      key: 'collectedAt',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag color={status === 'Active' ? 'green' : 'default'}>{status}</Tag>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button 
            type="link" 
            icon={<EyeOutlined />} 
            onClick={() => {
              setCurrentProfile(record);
              setIsModalVisible(true);
            }}
          >
            View
          </Button>
          <Button type="link" icon={<EditOutlined />}>Edit</Button>
          <Button type="link" danger icon={<DeleteOutlined />}>Delete</Button>
        </Space>
      ),
    },
  ];

  const handleUpload = (info: any) => {
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  return (
    <Card 
      title="Device Profile Library" 
      extra={
        <Upload onChange={handleUpload} showUploadList={false}>
          <Button icon={<UploadOutlined />} type="primary">Import Profile</Button>
        </Upload>
      }
    >
      <Table columns={columns} dataSource={data} />

      <Modal 
        title="Device Profile Details" 
        visible={isModalVisible} 
        onOk={() => setIsModalVisible(false)} 
        onCancel={() => setIsModalVisible(false)}
        width={800}
      >
        {currentProfile && (
          <Descriptions bordered column={2}>
            <Descriptions.Item label="Manufacturer">{currentProfile.manufacturer}</Descriptions.Item>
            <Descriptions.Item label="Model">{currentProfile.model}</Descriptions.Item>
            <Descriptions.Item label="Android Version">{currentProfile.androidVersion}</Descriptions.Item>
            <Descriptions.Item label="Build Fingerprint">google/raven/raven:12/SP2A.220305.013.A3/8310256:user/release-keys</Descriptions.Item>
            <Descriptions.Item label="CPU Info">Google Tensor (8 cores)</Descriptions.Item>
            <Descriptions.Item label="Memory">12 GB</Descriptions.Item>
            <Descriptions.Item label="Screen Resolution">1440 x 3120</Descriptions.Item>
            <Descriptions.Item label="Sensors">Accelerometer, Gyroscope, Magnetometer, Proximity...</Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </Card>
  );
};

export default DeviceProfileManagement;
